import 'select2';
import 'select2/dist/css/select2';
import '../entrypoints/src/admin/jquery_plugins/dynamic_option_select2';
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'inputFixedValue', 'fixedValue', 'frequencyValues', 'activityNameIdentification' ];

  connect() {
    $('input[name="activity[fixed_value]"]:checked')[0].dispatchEvent(new Event('change'));
    this.dropdownToggleBatches = this.element.querySelector('#toggle-batches');
    !!this.dropdownToggleBatches && this.dropdownToggleBatches.addEventListener('change', (ev) => this.toggleBatches());
  }

  toggleBatches() {
    this.element.querySelectorAll('.batches .at-batches .entry-card').forEach(($entry) => {
      let selectInactives = this.dropdownToggleBatches.selectedOptions[0].dataset.value == 'Ativas',
        toggleShow = selectInactives ^ $entry.classList.contains('inactive');
      $entry.classList.toggle('d-none', !toggleShow);
      $entry.closest('turbo-frame').classList.toggle('d-none', !toggleShow);
    });
  }

  // stimulus-events
  fixedValueChanged(ev) {
    let isFixedValue = ev.currentTarget.checked && ev.currentTarget.value === 'true';
    this.fixedValueTarget.classList.toggle('hidden', !isFixedValue);
    this.frequencyValuesTarget.classList.toggle('hidden', isFixedValue);
  }
}